<template>
    <div class="d-flex align-items-center">
        <span class="mr-2">{{ word }}</span>
        <vue-timepicker
            ref="timepicker"
            class="--mp"
            :class="selectedLocal && selectedLocal.length ? '--selected' : ''"
            v-model="selectedLocal"
            format="HH:mm"
            placeholder="-"
            :minute-interval="10"
            @open="fitInViewport"
            :drop-direction="dropDirection"
        ></vue-timepicker>
    </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    components: {
        VueTimepicker
    },
    props: {
        word: {
            type: String,
            default: ''
        },
        selected: {
            type: String,
            required: false
        },
        dropDirection: {
            type: String,
            default: 'down'
        }
    },
    computed: {
        selectedLocal: {
            get() {
                return this.selected
            },
            set(val) {
                if (typeof val === 'object') {
                    const hour = val.HH ? val.HH : '00'
                    const minute = val.mm ? val.mm : '00'
                    val = `${hour}:${minute}`
                }
                this.$emit('change', val)
            }
        }
    },
    methods: {
        fitInViewport() {
            const timepicker = this.$refs.timepicker.$el
            const dropdown = timepicker.querySelector('.dropdown')
            dropdown.style = 'block'
            const rect = dropdown.getBoundingClientRect()
            if (
                rect.bottom >=
                (window.innerHeight || document.documentElement.clientHeight)
            ) {
                dropdown.style.top = 'auto'
                dropdown.style.bottom = '0'
            }
            if (
                rect.right >=
                (window.innerWidth || document.documentElement.clientWidth)
            ) {
                dropdown.style.left = 'auto'
                dropdown.style.right = '0'
            }
        }
    }
}
</script>
